var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"Gmaps"}}),_c('remote-js',{attrs:{"jsUrl":"https://maps.googleapis.com/maps/api/js?key=AIzaSyB6ocCOSA_6fQiOiMUZAJKKv66sq7yksK8&libraries=places&language=en&sessiontoken =61654819d5215","js-load-call-back":_vm.initAutocomplete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }